import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const grantVipInvitation = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { activateVipInvitation } = await import("./vip-invitation.server");
    // Identity always comes from the authenticated request, never the form.
    return activateVipInvitation(context.userId);
  });
